import { dark } from './dark'
import { light } from './light'
import { stitchesConfig } from './stitches.config'

const { styled, css, keyframes, globalCss, createTheme, theme } = stitchesConfig

export { light, dark, styled, css, keyframes, globalCss, createTheme, theme }
